import classNames from "classnames";
import React from "react";
import "./BFPageSwitch.scss";

interface BFPageSwitchProps {
  renderPage1: (active: boolean) => React.ReactNode;
  renderPage2: (active: boolean) => React.ReactNode;
  switch: boolean;
  relativeToFirstPage?: boolean;
  className?: string;
}
const BFPageSwitch = (props: BFPageSwitchProps) => {
  return (
    <div
      className={classNames("bf-page-switch", props.className, {
        "bf-page-switch-active": props.switch,
        "__relative-to-first-page": props.relativeToFirstPage,
      })}
    >
      <div className={`bf-page-entry bf-page-1`}>
        {props.renderPage1(!props.switch)}
      </div>
      <div className={`bf-page-entry bf-page-2`}>
        {props.renderPage2(props.switch)}
      </div>
    </div>
  );
};

export default BFPageSwitch;
